window.required = { init, isValid, getErrors, setFieldRequired, unsetFieldRequired };

document.addEventListener('DOMContentLoaded', init);

function init() {
    Array.from(document.querySelectorAll('[data-required],[required]')).forEach((node) => {
        setFieldRequired(node);
    });
}

function setFieldRequired(node) {
    updateClasses(undefined, node);

    if ((node.tagName === 'INPUT' && node.type === 'text') || node.tagName === 'TEXTAREA') {
        node.addEventListener('keyup', updateClasses);
    }

    node.addEventListener('change', updateClasses);
}

function unsetFieldRequired(node) {
    updateClasses(undefined, node);

    if ((node.tagName === 'INPUT' && node.type === 'text') || node.tagName === 'TEXTAREA') {
        node.removeEventListener('keyup', updateClasses);
    }

    node.removeEventListener('change', updateClasses);
}

function updateClasses(event, target) {
    if (event) target = event.target;

    let nodes = [target];
    let className = 'form-control-danger';

    if (target.tagName === 'INPUT') {
        if (target.hasAttribute('data-document-field')) {
            const input = target.parentElement.querySelector('div.form-control');
            if (input) nodes.push(input);
        } else if (target.type === 'checkbox') {
            className = 'required';
            const wrap = util.parent(target, 'div.custom-switch, div.form-check');
            if (wrap) nodes.push(wrap);
        } else if (target.type === 'radio') {
            className = 'required';
            const group = util.parent(target, 'div.mb-3');

            if (group) {
                const wraps = group.querySelectorAll('div.form-check');
                if (wraps.length) nodes = Array.from(wraps);
            }
        } else {
            ['date', 'month', 'time'].some((type) => {
                if (target.classList.contains(`form-control-${type}picker`)) {
                    if (target._flatpickr && target._flatpickr.altInput) {
                        nodes.push(target._flatpickr.altInput);
                    }

                    return true;
                }

                return false;
            });
        }
    }

    if (!target.required || hasValue(target)) {
        nodes.forEach((node) => node.classList.remove(className));
    } else {
        nodes.forEach((node) => node.classList.add(className));
    }
}

function hasValue(node) {
    if (node.tagName === 'INPUT') {
        if (node.type === 'checkbox') return node.checked;
        if (node.type === 'radio') {
            const selector = `input[name="${node.name}"][type="radio"]:checked`;
            return !!document.querySelectorAll(selector).length;
        }
    }

    return !!node.value;
}

function getEmptyRequiredFields() {
    return Array.from(document.querySelectorAll('[required]'))
        .filter((node) => !util.parent(node, 'section[data-edit-row-template]'))
        .filter((node) => !hasValue(node));
}

function isValid() {
    return !getEmptyRequiredFields().length;
}

function getErrors() {
    const emptyRequiredFields = getEmptyRequiredFields();

    const ul = document.createElement('ul');

    emptyRequiredFields.forEach((node) => {
        let { id } = node;

        const numberOfUnderScores = (id.match(/__/g) || []).length;

        /*
        The number of underscores determines whether the input field is a radio button
        or is a part of a table. No underscores is a regular input field
        */
        if (numberOfUnderScores === 1) {
            id = id.split('__')[0];
        } else if (numberOfUnderScores === 2) {
            const idArray = id.split('-');
            id = `${idArray[0]}-${idArray[1]}`;
        }

        const parentContainer = $(node).closest('.question')[0];
        const questionHeading = parentContainer.querySelector('.question-heading')
            || parentContainer.querySelector(`#${id}-label`);
        const labelText = questionHeading.textContent.trim().replace(/:$/g, '');
        const li = createErrorListItem(id, labelText);

        if (!ul.querySelector(`li[rel="${id}"]`)) {
            ul.append(li);
        }

    });

    return ul;
}

function createErrorListItem(id, label) {
    const li = document.createElement('li');

    li.setAttribute('rel', id);
    li.textContent = label;

    return li;
}
